import { TERRAGRUNT_TOOL_INFO_TOOLTIP } from "constants/terragruntTools";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";

import { StackSettingsGetTooltipHelperReturnType } from "../../types";

export const getToolTooltip = (): StackSettingsGetTooltipHelperReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>Tool</TooltipModalTitle>
      <TooltipModalBody align="start">{TERRAGRUNT_TOOL_INFO_TOOLTIP}</TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});

export const getSkipReplanTooltip = (): StackSettingsGetTooltipHelperReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>Skip replan</TooltipModalTitle>
      <TooltipModalBody align="start">
        Skip the second planning phase during the apply stage by reusing the saved plan. Applies to
        both Run All and non-Run All stacks.
        <br />
        <br />
        Warning: this means any mocked_outputs referenced during planning will be applied as-is. Do
        not enable this together with mocked_outputs unless you fully understand the implications —
        your apply may execute against mocked values rather than real ones.
      </TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});
